import React from 'react'
import HintPopover from "../../../../gd-ui/hint-popover/hint-popover"
import {FieldPillProps} from "../../../proto/components/pill"
import {ColorPalette} from "../../../color-coding/color-coding"
import ProjectSession from "../../../../model2/project/project-session"
import {isBulkSelection} from "../../../../gd/right-click-menu"

export default function FieldTag_Pill(props: FieldPillProps) {
    // is required in case tag has changed color or name but field is not updated (view is not reRendered)
    const tag: ProjectSession | null = gd.session.projects.get(props.option?.value)

    if (!tag) return null

    const onClick = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()

        if (gd.isSharedView) {
            return
        }

        if (props.onClick) {
            props.onClick(props.option, e)
            return
        }

        gd.navigation.goToProject(props.option.value)
    }

    const onDelete = (e: React.MouseEvent) => {
        if (isBulkSelection(e)) return
        e.stopPropagation()

        if (props.onDelete) {
            props.onDelete(props.option, e);
        }
    }

    const size = props.size || 26

    const classes = Classes('gd-tag-tile', props.className, {
        'size-26': size === 26,
        'size-24': size === 24,
    })

    const style = {
        backgroundColor: gd.skin.colors.paleBGColor({
            colorNumber: tag.color!,
            corePalette: ColorPalette.CORE
        }),
        /*borderColor: gd.skin.colors.paleBorderColor({
            colorNumber: tag.color!,
            corePalette: CorePalette.CORE
        })*/
    }

    const iconStyle = {
        color: gd.skin.colors.mainColor({
            colorNumber: tag.color!,
            corePalette: ColorPalette.CORE
        })
    }

    const hintRequired = tag.name!.length > 6 || false //this.props.showIcon ? this.props.tag.name.length > 6 : this.props.tag.name.length > 9;


    return (
        <div className={classes} style={style} onClick={onClick}>
            <div className="i5-tag-solid" style={iconStyle}/>
            <div className="txt-truncate lh-20">
                {tag.name}
            </div>
            {!gd.isSharedView && props.onDelete &&
                <div className="delete-icon i5-delete" onClick={onDelete}></div>}

            {hintRequired && <HintPopover hint={tag.name}/>}
        </div>
    );

}

